const sportImg = [
  {
    title: 'BUCS Super Rugby Championship final',
    img: 'https://i.imgur.com/bqWv3BX.jpg',
  },
  {
    title: 'england vs malaysia filed hockey',
    img: 'https://i.imgur.com/v6AdsEP.jpg',
  },
  {
    title: 'female artistic gymnast',
    img: 'https://i.imgur.com/MebYiTv.jpg',
  },
  {
    title: 'BBL basketball',
    img: 'https://i.imgur.com/f9nf4Xi.jpg',
  },
  {
    title: 'Manchester City win Charity Shield',
    img: 'https://i.imgur.com/LsKn6sB.jpg',
  },
  {
    title: 'Heyemaker Boxing',
    img: 'https://i.imgur.com/633VJBM.jpg',
  },
  {
    title: 'SportsAid marathon',
    img: 'https://i.imgur.com/kAPfbih.jpg',
  },
  {
    title: 'Greg Rutherford',
    img: 'https://i.imgur.com/6y32U4i.jpg',
  },
  {
    title: 'Cage Warriors',
    img: 'https://i.imgur.com/qkdrlc4.jpg',
  },
  {
    title: 'Ben Whittaker',
    img: 'https://i.imgur.com/AFbczSt.jpg',
  },
  {
    title: 'Mesut Ozil',
    img: 'https://i.imgur.com/RIJe3Vx.jpg',
  },
  {
    title: 'girl playing tennis',
    img: 'https://i.imgur.com/5Dp9yGk.jpg',
  },
  {
    title: 'longest game of rugby union',
    img: 'https://i.imgur.com/Yw8mTiI.jpg',
  },
  {
    title: 'Danusia Francis',
    img: 'https://i.imgur.com/FooE6Ug.jpg',
  },
  {
    title: 'BUCS Super Rugby Championship final',
    img: 'https://i.imgur.com/iLT1F7C.jpg',
  },
  {
    title: 'Great Britain Basketball',
    img: 'https://i.imgur.com/aERegnz.jpg',
  },
  {
    title: 'Tottenham vs Rochdale football',
    img: 'https://i.imgur.com/I5fSGXG.jpg',
  },
  {
    title: 'Mo Salah',
    img: 'https://i.imgur.com/MdeMSfT.jpg',
  },
  {
    title: 'Leeds United vs Southend football',
    img: 'https://i.imgur.com/pW0pWpN.jpg',
  },
  {
    title: 'boxing match',
    img: 'https://i.imgur.com/q0N3uQd.jpg',
  },
  {
    title: 'british athletics',
    img: 'https://i.imgur.com/cbIz5aO.jpg',
  },
  {
    title: 'max whitlock',
    img: 'https://i.imgur.com/BgSgttD.jpg',
  },
  {
    title: 'middlesbrough fc ',
    img: 'https://i.imgur.com/nBTLmjo.jpg',
  },
  {
    title: 'cage warriors',
    img: 'https://i.imgur.com/8Im7erA.jpg',
  },
  {
    title: 'world cup of gymnastics',
    img: 'https://i.imgur.com/gF5FlIn.jpg',
  },
  {
    title: 'Pierre-Emerick Aubameyang',
    img: 'https://i.imgur.com/CoX7UD1.jpg',
  },
  {
    title: 'brentford vs qpr football',
    img: 'https://i.imgur.com/d8fnm7n.jpg',
  },
  {
    title: 'leeds united vs qpr football',
    img: 'https://i.imgur.com/pLZvH2n.jpg',
  },
  {
    title: 'sam oldham gymnastics',
    img: 'https://i.imgur.com/J3RrR3J.jpg',
  },
  {
    title: 'england hockey',
    img: 'https://i.imgur.com/y0NNhfm.jpg',
  },
];

export default sportImg;
